import React from "react";
import styled from "styled-components";

import { Resource } from "@examspark/types";

import AssetIconAlert from "./asset-icons/AssetIconAlert";

interface Props {
  item?: Resource;
  type?:
    | "exam"
    | "question"
    | "blueprint"
    | "item"
    | "task"
    | "stimulus"
    | "job"
    | "resource"
    | string;
}

const Styled = styled.div<Props>`
  width: 14px;
  height: 14px;
  border-radius: 0.2rem;

  background-color: ${(props) => {
    switch (props.type) {
      case "blueprint":
        return "#5A65BB";
      case "exam":
        return "#b38078";
      case "question":
      case "item":
        return "#9793ad";
      case "task":
        return "#555";
      case "stimulus":
      case "resource":
        return "#6E6F9C";
      case "vocabulary":
        return "#555";
      case "job":
        return "#af8989";
      default:
        return "#888";
    }
  }};

  svg {
    display: block;
    fill: #fff;
    width: 100%;
  }
`;

/**
 * Render colored asset-type icon depending on the value of asset's `sk` field.
 *
 */
const AssetTypeIcon: React.FC<React.PropsWithChildren<Props>> = (props) => {
  let type: string | undefined = props.type;
  if (props.item) {
    const parts = props.item.sk.split("#");
    type = parts[0];
  }

  if (type === "issue") {
    return <AssetIconAlert />;
  }

  return (
    <Styled {...props} type={type || props.type} title={type}>
      {type === "blueprint" && (
        <svg viewBox="0 0 14 14">
          <g>
            <rect x="3" y="4" width="3" height="3" />
            <rect x="3" y="8" width="3" height="3" />
            <rect x="7" y="8" width="3" height="3" />
          </g>
        </svg>
      )}
      {(type === "stimulus" || type === "resource") && (
        <svg viewBox="0 0 18 18">
          <polygon points="12,6.4 8.1,10.3 6,7.7 3,12 15,12" />
        </svg>
      )}
      {type === "exam" && (
        <svg viewBox="0 0 18 18">
          <g>
            <path
              d="M9.5,12.9l-0.6-2.1H5.7l-0.6,2.1h-2l3.1-8.7h2.2l3.1,8.7H9.5z M8.4,9.3c-0.6-1.9-0.9-2.9-1-3.2C7.4,5.9,7.3,5.7,7.3,5.5
				C7.2,6,6.8,7.3,6.2,9.3H8.4z"
            />
          </g>
          <g>
            <path d="M12.8,6.7h-1.7v-1h1.7V4.1h1v1.7h1.7v1h-1.7v1.7h-1V6.7z" />
          </g>
        </svg>
      )}
      {type === "task" && (
        <svg viewBox="0 0 18 18">
          <g>
            <path
              d="M7.8,12.7c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3-0.1-0.4-0.1L4.2,9.8c-0.3-0.3-0.3-0.8,0-1.1l0.4-0.4
			c0.3-0.3,0.8-0.3,1.1,0l1.8,1.8l4.9-4.9c0.3-0.3,0.8-0.3,1.1,0l0.4,0.4c0.3,0.3,0.3,0.8,0,1.1L7.8,12.7z"
            />
          </g>
        </svg>
      )}
      {type === "job" && (
        <svg viewBox="0 0 18 18">
          <g>
            <g>
              <path
                d="M14.1,8.1l-1.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6l0.6-1.1c0.1-0.1,0.1-0.3,0-0.4l-0.9-0.9
				c-0.1-0.1-0.3-0.1-0.4,0l-1.1,0.6c-0.2-0.1-0.4-0.2-0.6-0.3L9.9,3.9c0-0.1-0.2-0.2-0.3-0.2H8.4C8.2,3.7,8.1,3.8,8,3.9L7.7,5.1
				C7.5,5.2,7.3,5.3,7.1,5.4L6,4.8c-0.1-0.1-0.3-0.1-0.4,0L4.8,5.7c-0.1,0.1-0.1,0.3,0,0.4l0.6,1.1C5.3,7.3,5.2,7.6,5.1,7.8L3.9,8.1
				c-0.1,0-0.2,0.2-0.2,0.3v1.2c0,0.1,0.1,0.3,0.2,0.3l1.2,0.3c0.1,0.2,0.2,0.4,0.3,0.6l-0.6,1.1c-0.1,0.1-0.1,0.3,0,0.4l0.9,0.9
				c0.1,0.1,0.3,0.1,0.4,0l1.1-0.6c0.2,0.1,0.4,0.2,0.6,0.3L8,14.1c0,0.1,0.2,0.2,0.3,0.2h1.2c0.1,0,0.3-0.1,0.3-0.2l0.3-1.2
				c0.2-0.1,0.4-0.2,0.6-0.3l1.1,0.6c0.1,0.1,0.3,0.1,0.4,0l0.9-0.9c0.1-0.1,0.1-0.3,0-0.4l-0.6-1.1c0.1-0.2,0.2-0.4,0.3-0.6
				l1.2-0.3c0.1,0,0.2-0.2,0.2-0.3V8.4C14.3,8.2,14.2,8.1,14.1,8.1z M9,10.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6
				c0.9,0,1.6,0.7,1.6,1.6C10.5,9.9,9.8,10.6,9,10.6z"
              />
            </g>
          </g>
        </svg>
      )}
      {(type === "question" || type === "item") && (
        <svg viewBox="0 0 18 18">
          <path d="M8.7,12.4c-0.7,0-1.2,0.6-1.2,1.2c0,0.7,0.5,1.2,1.2,1.2c0.7,0,1.2-0.6,1.2-1.2C9.9,13,9.3,12.4,8.7,12.4z" />
          <path
            d="M8.9,3.2c-2.1,0-3.1,1.3-3.1,2.1c0,0.6,0.5,0.9,1,0.9C7.6,6.2,7.2,5,8.8,5c0.8,0,1.4,0.3,1.4,1.1
		c0,0.9-0.9,1.3-1.4,1.8c-0.5,0.4-1.1,1-1.1,2.4c0,0.8,0.2,1.1,0.9,1.1c0.8,0,0.9-0.3,0.9-0.7c0-0.8,0-1.3,0.9-2
		c0.4-0.3,1.8-1.4,1.8-2.9S10.9,3.2,8.9,3.2z"
          />
        </svg>
      )}

      {/* <svg x="0px" y="0px" viewBox="0 0 14 14" fill="#fff">
        <g>
          <path
            d="M3.1,11.1V10L3.7,10L6,3.5h2l2.3,6.4l0.5,0.1v1.1H7.9V10L8.4,10L8.2,9.1H5.7L5.5,10L6,10v1.1H3.1z M6.1,7.9
		h1.7L7.1,5.6L7,5.3h0L6.8,5.6L6.1,7.9z"
          />
        </g>
      </svg> */}
    </Styled>
  );
};

export default AssetTypeIcon;
